import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result } from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { ModerationTermsDTO } from './ModerationTermsDTO';

export interface ModerationTermsRepositorySpec {
    getModerationTerms(locale: Locale): Promise<Result<ModerationTermsDTO>>;
}

export const MODERATION_LIST_KEY = 'moderationList';

export class ModerationTermsRepository extends ConfigByKeyRepository implements ModerationTermsRepositorySpec {
    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async getModerationTerms(locale: Locale): Promise<Result<ModerationTermsDTO>> {
        return await this.getConfigByKey(MODERATION_LIST_KEY, { locale }, (value) => ModerationTermsDTO.parse(value));
    }
}
